import { 
    apiRequest,
    cutiCreate
} from '../../../../../services/adapters/kepegawaian/cutiService'

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", cutiCreate, {
            body: query
        }, true)
    }

}

export default CreateRepository